import { createFileRoute } from '@tanstack/react-router';
import LoadingPage from '../../../../../../../../components/shared/page-components/LoadingPage';
import WalletPage from '../../../../../../../../components/source-management/wallets/wallet-page/WalletPage';

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet',
)({
  component: WalletPage,
  pendingComponent: () => <LoadingPage loadingPage />,
  staticData: {
    isClientRoute: true,
    meta: {
      title: 'Wallet Details | Ledgible',
    },
  },
});
